<template>

        <div class="content" @scroll="handleScroll($event)">
             <ul class="activity-list">
              <li v-for="(item, index) in informationData" :key="'activity'+index" class="activity">
                <div class="activity-left">
                       <img v-lazy="$axios.defaults.baseURL+item.reallyFilePath" alt="display" />
                </div>
             
                <div class="activity-right">
                  <p @click="jumpItem('/volunteer/home/activityDetail',item.id)" :title="item.title" class="titlex">
                    {{ item.title }}
                  </p>
                  <p class="date">发布日期：{{ item.publishTime }} <span v-if="item.viewCount">浏览次数：</span> <span v-if="item.viewCount">{{
                      item.viewCount
                    }}次</span></p>
        
           
                  <p v-html="item.content" class="text"></p>
                </div>
              </li>
            </ul>
   
            <div class="load" v-if="nextFlag">
                  <a-spin v-if="tipMessage != '数据已加载完!'"/><span class="load-text">{{tipMessage}}</span>
            </div>
            <div v-if="finalFlag" class="load">
                    <span class="load-text">{{tipMessage}}</span>
            </div>
        </div>

</template>
<script>

export default {
     name: 'volunteerActivity',
  props: {
  },

  data(){
         
     return {
                 informationData:[
    
                    //  {
                    //      reallyFilePath:require("../../assets/imgs/水彩画.png"),
                    //      title:'上饶美术馆志愿者宣讲活动走进中学1111111111111111111111111111111111111111111111111111111',
                    //      id:'1',
                    //      publishTime:'2021-03-09',
                    //      viewCount:'913',
                    //      content:'辛丑农历新年刚过，“草树知春”的时节便如期而至。由天津美术馆主办的“春风十里—京津小幅风景油画邀请展”于2021年3月12日至4月20日与观众见面，意在为我们这座城市的艺术园地及精神文化生活，带来一片春的明媚与春的色彩。受邀参加此次展览的艺术家们来自于京津两地。他们之中有享誉国内美术界的老艺术家，也有有正值创作盛年的画坛翘楚，还有活力充沛的青年才俊。他们以经典的油画语言，从不同视角，描摹大千世界的风光景致，展现蓬勃向上的社会生活，揭示其间蕴含的美的韵律。笔致翩翩，美不胜收。绘画艺术的审美价值从不以篇幅大小分高下。小幅风景油画作为油画艺术与生俱来的一个品种，由于它更接近于画家对艺术的“本真”思考，语境鲜活灵动，因而魅力独具，广受青睐。'
                    //  },
                    //    {
                    //      reallyFilePath:require("../../assets/imgs/水彩画.png"),
                    //      title:'上饶美术馆志愿者宣讲活动走进中学',
                    //      id:'2',
                    //      publishTime:'2021-03-09',
                    //      viewCount:'913',
                    //      content:'辛丑农历新年刚过，“草树知春”的时节便如期而至。由天津美术馆主办的“春风十里—京津小幅风景油画邀请展”于2021年3月12日至4月20日与观众见面，意在为我们这座城市的艺术园地及精神文化生活，带来一片春的明媚与春的色彩。受邀参加此次展览的艺术家们来自于京津两地。他们之中有享誉国内美术界的老艺术家，也有有正值创作盛年的画坛翘楚，还有活力充沛的青年才俊。他们以经典的油画语言，从不同视角，描摹大千世界的风光景致，展现蓬勃向上的社会生活，揭示其间蕴含的美的韵律。笔致翩翩，美不胜收。绘画艺术的审美价值从不以篇幅大小分高下。小幅风景油画作为油画艺术与生俱来的一个品种，由于它更接近于画家对艺术的“本真”思考，语境鲜活灵动，因而魅力独具，广受青睐。'
                    //  },
                    //    {
                    //      reallyFilePath:require("../../assets/imgs/xshd.png"),
                    //      title:'上饶美术馆志愿者宣讲活动走进中学',
                    //      id:'3',
                    //      publishTime:'2021-03-09',
                    //      viewCount:'913',
                    //      content:'辛丑农历新年刚过，“草树知春”的时节便如期而至。由天津美术馆主办的“春风十里—京津小幅风景油画邀请展”于2021年3月12日至4月20日与观众见面，意在为我们这座城市的艺术园地及精神文化生活，带来一片春的明媚与春的色彩。受邀参加此次展览的艺术家们来自于京津两地。他们之中有享誉国内美术界的老艺术家，也有有正值创作盛年的画坛翘楚，还有活力充沛的青年才俊。他们以经典的油画语言，从不同视角，描摹大千世界的风光景致，展现蓬勃向上的社会生活，揭示其间蕴含的美的韵律。笔致翩翩，美不胜收。绘画艺术的审美价值从不以篇幅大小分高下。小幅风景油画作为油画艺术与生俱来的一个品种，由于它更接近于画家对艺术的“本真”思考，语境鲜活灵动，因而魅力独具，广受青睐。'
                    //  },
                    //    {
                    //      reallyFilePath:require("../../assets/imgs/水彩画.png"),
                    //      title:'上饶美术馆志愿者宣讲活动走进中学',
                    //      id:'4',
                    //      publishTime:'2021-03-09',
                    //      viewCount:'913',
                    //      content:'辛丑农历新年刚过，“草树知春”的时节便如期而至。由天津美术馆主办的“春风十里—京津小幅风景油画邀请展”于2021年3月12日至4月20日与观众见面，意在为我们这座城市的艺术园地及精神文化生活，带来一片春的明媚与春的色彩。受邀参加此次展览的艺术家们来自于京津两地。他们之中有享誉国内美术界的老艺术家，也有有正值创作盛年的画坛翘楚，还有活力充沛的青年才俊。他们以经典的油画语言，从不同视角，描摹大千世界的风光景致，展现蓬勃向上的社会生活，揭示其间蕴含的美的韵律。笔致翩翩，美不胜收。绘画艺术的审美价值从不以篇幅大小分高下。小幅风景油画作为油画艺术与生俱来的一个品种，由于它更接近于画家对艺术的“本真”思考，语境鲜活灵动，因而魅力独具，广受青睐。'
                    //  },
                    //    {
                    //      reallyFilePath:require("../../assets/imgs/水彩画.png"),
                    //      title:'上饶美术馆志愿者宣讲活动走进中学',
                    //      id:'5',
                    //      publishTime:'2021-03-09',
                    //      viewCount:'913',
                    //      content:'辛丑农历新年刚过，“草树知春”的时节便如期而至。由天津美术馆主办的“春风十里—京津小幅风景油画邀请展”于2021年3月12日至4月20日与观众见面，意在为我们这座城市的艺术园地及精神文化生活，带来一片春的明媚与春的色彩。受邀参加此次展览的艺术家们来自于京津两地。他们之中有享誉国内美术界的老艺术家，也有有正值创作盛年的画坛翘楚，还有活力充沛的青年才俊。他们以经典的油画语言，从不同视角，描摹大千世界的风光景致，展现蓬勃向上的社会生活，揭示其间蕴含的美的韵律。笔致翩翩，美不胜收。绘画艺术的审美价值从不以篇幅大小分高下。小幅风景油画作为油画艺术与生俱来的一个品种，由于它更接近于画家对艺术的“本真”思考，语境鲜活灵动，因而魅力独具，广受青睐。'
                    //  }

                 ],
      page: {
        pageNum: 1,
        pageSize: 5,
      },//分页
                  nextFlag:true,   //下一个请求标识
                  finalFlag:false, //所有请求完成标识
                  tipMessage:'努力加载中...',
              
             }
     
  },
   created: function () {
 
 
       this.getList();
           console.log(11)
    },
    mounted: function () {
      console.log(22)
    },
    activated: function () {

        console.log(33)
    },
    deactivated: function () {
      console.log(44)
  
    },
     beforeDestroy() {
         
              console.log(55)
     },
  methods:{
    
         jumpItem(link,id)
      {
     
          if(id)
          {
        
              this.$router.push({path:link,query:{id:id}})
          }
          else
          {
              this.$router.push({path: link});
          }
      },//路由跳转函数
     handleScroll (event) {
   
        let Scroll = event.target;
        //滚动条到底部的条件
        if(Scroll.scrollTop +Scroll.clientHeight == Scroll.scrollHeight)
        {
            console.log(Scroll.scrollTop,'Scroll.scrollTop');
            console.log(Scroll.clientHeight,'Scroll.clientHeight');
            console.log(Scroll.scrollHeight,'Scroll.scrollHeight');
        }
        if(Scroll.scrollTop +Scroll.clientHeight == Scroll.scrollHeight && !this.nextFlag && !this.finalFlag){

      this.nextFlag = true;
        this.page.pageNum++;
        setTimeout(()=>{ this.getList();},1000);
    
        }
	},
  async getList()
  {
        let params =  this.page;
        await this.$sr_api.getVolunteerActivityList(params).then(
          (res)=>{
            let length = res.rows.length;
            let arr = [];
            for (let i = 0; i < length ; i++)
            {
                let tempData = {};
                tempData.reallyFilePath = res.rows[i].params.reallyFilePath;
                tempData.title = res.rows[i].title;
                tempData.id = res.rows[i].id;
                tempData.publishTime = res.rows[i].publishTime;
                tempData.viewCount = res.rows[i].viewCount;
                tempData.content = res.rows[i].content;
                arr.push(tempData);
            }
             this.informationData=[... this.informationData,...arr];
            if (res.rows.length == 0)
            {
              this.tipMessage = '数据已加载完!'
               this.finalFlag = true;
            }
          this.nextFlag = false;
          }
        );
  }
  }
}
</script>
<style scoped>
    img {
    font-size: 18px;
}
     .content {
        width: 860px;
        height: 990px;
        margin-top: 40px;
        padding: 0 40px 0 30px;
        background-color: #fff;
        border-radius: 10px;
         overflow: scroll;
    }
    .content::-webkit-scrollbar {
  display: none;
}
     .content .activity-list {
        width: 100%;
        height: auto;
        background: #ffffff;
     }
    .content .activity {
           display: flex;
           justify-content: space-between;
           height: 210px;
           margin-top: 30px;
           padding-bottom: 30px;
           width: 100%;
            border-bottom: 1px solid #eeeeee;
    }
     .content  .activity-left {
         width: 180px;
         height: 180px;
     }
     .content  .activity-left  >img {
          width: 100%;
          height: 100%;
      }
       .content  .activity-right {
           width: 595px;
               height: 180px;
       }
    .content  .activity-right .titlex {
      width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        height: 24px;
        font-size: 24px;
        line-height: 24px;
        color: #222222;
        font-family: SourceHanSansCN;
        font-weight: 500;
        cursor: pointer;
    }
    .content  .activity-right .date {
        margin: 20px 0 10px;
        color: #666666;
        font-weight: 500;
        font-family: SourceHanSansCN;
        height: 14px;
        font-size: 14px;
        line-height: 14px;
    }
    .content  .activity-right .text {
        height: 114px;
        font-size: 14px;
        line-height: 24px;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #222222;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
    }

    .load {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: center;
  transition: all 2s;
}
::v-deep .ant-spin-dot-item {
  background-color: #b78c0d;
  /* color: #b78c0d; */
}
::v-deep .ant-spin-dot-item {
  background-color: #b78c0d;
  /* color: #b78c0d; */
}
.load-text {
  margin-left: 10px;
  font-size: 14px;
}
</style>